export const pageConfigs = {
    w1: {
      MAIN_SECTION_WIDTH1: "30\"",
      MAIN_SECTION_WIDTH2: "25\"",
      MAIN_SECTION_WIDTH3: "30\"",
      MAIN_SECTION_WIDTH4: "25\"",
      MAIN_SECTION_WIDTH5: "30\"",
      WITH_UPPER_ONE_SECTION: "None",
      TOP_ROW_HEIGHT: "20\"",
      ARCH_LEG_HEIGHT: "0\"",
      WITH_MAIN_ROW_SECTIONS: "1",
      MAIN_ROW_HEIGHT: "50\"",
      MAIN_ROW_WIDTH:  "150\"",
    },
    w2: {
      MAIN_SECTION_WIDTH1: "28\"",
      MAIN_SECTION_WIDTH2: "22\"",
      MAIN_SECTION_WIDTH3: "28\"",
      MAIN_SECTION_WIDTH4: "22\"",
      MAIN_SECTION_WIDTH5: "28\"",
      WITH_UPPER_ONE_SECTION: "1",
      TOP_ROW_HEIGHT: "18\"",
      ARCH_LEG_HEIGHT: "2\"",
      WITH_MAIN_ROW_SECTIONS: "1",
      MAIN_ROW_HEIGHT: "52\"",
      MAIN_ROW_WIDTH:  "150\"",
    },
    w3: {
        MAIN_SECTION_WIDTH1: "40\"",
        MAIN_SECTION_WIDTH2: "25\"",
        MAIN_SECTION_WIDTH3: "30\"",
        MAIN_SECTION_WIDTH4: "25\"",
        MAIN_SECTION_WIDTH5: "30\"",
        WITH_UPPER_ONE_SECTION: "Arch",
        TOP_ROW_HEIGHT: "20\"",
        ARCH_LEG_HEIGHT: "0\"",
        WITH_MAIN_ROW_SECTIONS: "1",
        MAIN_ROW_HEIGHT: "50\"",
        MAIN_ROW_WIDTH:  "150\"",
    },
    w4: {
        MAIN_SECTION_WIDTH1: "30\"",
        MAIN_SECTION_WIDTH2: "25\"",
        MAIN_SECTION_WIDTH3: "30\"",
        MAIN_SECTION_WIDTH4: "25\"",
        MAIN_SECTION_WIDTH5: "30\"",
        WITH_UPPER_ONE_SECTION: "None",
        TOP_ROW_HEIGHT: "20\"",
        ARCH_LEG_HEIGHT: "0\"",
        WITH_MAIN_ROW_SECTIONS: "2",
        MAIN_ROW_HEIGHT: "50\"",
        MAIN_ROW_WIDTH:  "150\"",
    },
    w5: {
        MAIN_SECTION_WIDTH1: "30\"",
        MAIN_SECTION_WIDTH2: "25\"",
        MAIN_SECTION_WIDTH3: "30\"",
        MAIN_SECTION_WIDTH4: "25\"",
        MAIN_SECTION_WIDTH5: "30\"",
        WITH_UPPER_ONE_SECTION: "1",
        TOP_ROW_HEIGHT: "20\"",
        ARCH_LEG_HEIGHT: "0\"",
        WITH_MAIN_ROW_SECTIONS: "2",
        MAIN_ROW_HEIGHT: "50\"",
        MAIN_ROW_WIDTH:  "150\"",
    },
    w6: {
        MAIN_SECTION_WIDTH1: "30\"",
        MAIN_SECTION_WIDTH2: "25\"",
        MAIN_SECTION_WIDTH3: "30\"",
        MAIN_SECTION_WIDTH4: "25\"",
        MAIN_SECTION_WIDTH5: "30\"",
        WITH_UPPER_ONE_SECTION: "Grid",
        TOP_ROW_HEIGHT: "20\"",
        ARCH_LEG_HEIGHT: "0\"",
        WITH_MAIN_ROW_SECTIONS: "2",
        MAIN_ROW_HEIGHT: "50\"",
        MAIN_ROW_WIDTH:  "150\"",
    },
    w7: {
        MAIN_SECTION_WIDTH1: "30\"",
        MAIN_SECTION_WIDTH2: "25\"",
        MAIN_SECTION_WIDTH3: "30\"",
        MAIN_SECTION_WIDTH4: "25\"",
        MAIN_SECTION_WIDTH5: "30\"",
        WITH_UPPER_ONE_SECTION: "Arch",
        TOP_ROW_HEIGHT: "20\"",
        ARCH_LEG_HEIGHT: "0\"",
        WITH_MAIN_ROW_SECTIONS: "2",
        MAIN_ROW_HEIGHT: "50\"",
        MAIN_ROW_WIDTH:  "150\"",
    },
    w8: {
        MAIN_SECTION_WIDTH1: "30\"",
        MAIN_SECTION_WIDTH2: "25\"",
        MAIN_SECTION_WIDTH3: "30\"",
        MAIN_SECTION_WIDTH4: "25\"",
        MAIN_SECTION_WIDTH5: "30\"",
        WITH_UPPER_ONE_SECTION: "None",
        TOP_ROW_HEIGHT: "20\"",
        ARCH_LEG_HEIGHT: "0\"",
        WITH_MAIN_ROW_SECTIONS: "3",
        MAIN_ROW_HEIGHT: "50\"",
        MAIN_ROW_WIDTH:  "150\"",
    },
    w9: {
        MAIN_SECTION_WIDTH1: "30\"",
        MAIN_SECTION_WIDTH2: "25\"",
        MAIN_SECTION_WIDTH3: "30\"",
        MAIN_SECTION_WIDTH4: "25\"",
        MAIN_SECTION_WIDTH5: "30\"",
        WITH_UPPER_ONE_SECTION: "1",
        TOP_ROW_HEIGHT: "20\"",
        ARCH_LEG_HEIGHT: "0\"",
        WITH_MAIN_ROW_SECTIONS: "4",
        MAIN_ROW_HEIGHT: "50\"",
        MAIN_ROW_WIDTH:  "150\"",
    },
    w10: {
        MAIN_SECTION_WIDTH1: "30\"",
        MAIN_SECTION_WIDTH2: "25\"",
        MAIN_SECTION_WIDTH3: "30\"",
        MAIN_SECTION_WIDTH4: "25\"",
        MAIN_SECTION_WIDTH5: "30\"",
        WITH_UPPER_ONE_SECTION: "Grid",
        TOP_ROW_HEIGHT: "20\"",
        ARCH_LEG_HEIGHT: "0\"",
        WITH_MAIN_ROW_SECTIONS: "3",
        MAIN_ROW_HEIGHT: "50\"",
        MAIN_ROW_WIDTH:  "150\"",
    },
    w11: {
        MAIN_SECTION_WIDTH1: "30\"",
        MAIN_SECTION_WIDTH2: "25\"",
        MAIN_SECTION_WIDTH3: "30\"",
        MAIN_SECTION_WIDTH4: "25\"",
        MAIN_SECTION_WIDTH5: "30\"",
        WITH_UPPER_ONE_SECTION: "Arch",
        TOP_ROW_HEIGHT: "20\"",
        ARCH_LEG_HEIGHT: "0\"",
        WITH_MAIN_ROW_SECTIONS: "3",
        MAIN_ROW_HEIGHT: "50\"",
        MAIN_ROW_WIDTH:  "150\"",
    },
    w12: {
        MAIN_SECTION_WIDTH1: "30\"",
        MAIN_SECTION_WIDTH2: "25\"",
        MAIN_SECTION_WIDTH3: "30\"",
        MAIN_SECTION_WIDTH4: "25\"",
        MAIN_SECTION_WIDTH5: "30\"",
        WITH_UPPER_ONE_SECTION: "None",
        TOP_ROW_HEIGHT: "20\"",
        ARCH_LEG_HEIGHT: "0\"",
        WITH_MAIN_ROW_SECTIONS: "4",
        MAIN_ROW_HEIGHT: "50\"",
        MAIN_ROW_WIDTH:  "150\"",
    },
    w13: {
        MAIN_SECTION_WIDTH1: "30\"",
        MAIN_SECTION_WIDTH2: "25\"",
        MAIN_SECTION_WIDTH3: "30\"",
        MAIN_SECTION_WIDTH4: "25\"",
        MAIN_SECTION_WIDTH5: "30\"",
        WITH_UPPER_ONE_SECTION: "1",
        TOP_ROW_HEIGHT: "20\"",
        ARCH_LEG_HEIGHT: "0\"",
        WITH_MAIN_ROW_SECTIONS: "4",
        MAIN_ROW_HEIGHT: "50\"",
        MAIN_ROW_WIDTH:  "150\"",
    },
    w14: {
        MAIN_SECTION_WIDTH1: "30\"",
        MAIN_SECTION_WIDTH2: "25\"",
        MAIN_SECTION_WIDTH3: "30\"",
        MAIN_SECTION_WIDTH4: "25\"",
        MAIN_SECTION_WIDTH5: "30\"",
        WITH_UPPER_ONE_SECTION: "Grid",
        TOP_ROW_HEIGHT: "20\"",
        ARCH_LEG_HEIGHT: "0\"",
        WITH_MAIN_ROW_SECTIONS: "4",
        MAIN_ROW_HEIGHT: "50\"",
        MAIN_ROW_WIDTH:  "150\"",
    },
    w15: {
        MAIN_SECTION_WIDTH1: "30\"",
        MAIN_SECTION_WIDTH2: "25\"",
        MAIN_SECTION_WIDTH3: "30\"",
        MAIN_SECTION_WIDTH4: "25\"",
        MAIN_SECTION_WIDTH5: "30\"",
        WITH_UPPER_ONE_SECTION: "Arch",
        TOP_ROW_HEIGHT: "20\"",
        ARCH_LEG_HEIGHT: "0\"",
        WITH_MAIN_ROW_SECTIONS: "4",
        MAIN_ROW_HEIGHT: "50\"",
        MAIN_ROW_WIDTH:  "150\"",
    },
    w16: {
        MAIN_SECTION_WIDTH1: "30\"",
        MAIN_SECTION_WIDTH2: "25\"",
        MAIN_SECTION_WIDTH3: "30\"",
        MAIN_SECTION_WIDTH4: "25\"",
        MAIN_SECTION_WIDTH5: "30\"",
        WITH_UPPER_ONE_SECTION: "None",
        TOP_ROW_HEIGHT: "20\"",
        ARCH_LEG_HEIGHT: "0\"",
        WITH_MAIN_ROW_SECTIONS: "5",
        MAIN_ROW_HEIGHT: "50\"",
        MAIN_ROW_WIDTH:  "150\"",
    },
    w17: {
        MAIN_SECTION_WIDTH1: "30\"",
        MAIN_SECTION_WIDTH2: "25\"",
        MAIN_SECTION_WIDTH3: "30\"",
        MAIN_SECTION_WIDTH4: "25\"",
        MAIN_SECTION_WIDTH5: "30\"",
        WITH_UPPER_ONE_SECTION: "1",
        TOP_ROW_HEIGHT: "20\"",
        ARCH_LEG_HEIGHT: "0\"",
        WITH_MAIN_ROW_SECTIONS: "5",
        MAIN_ROW_HEIGHT: "50\"",
        MAIN_ROW_WIDTH:  "150\"",
    },
    w18: {
        MAIN_SECTION_WIDTH1: "30\"",
        MAIN_SECTION_WIDTH2: "25\"",
        MAIN_SECTION_WIDTH3: "30\"",
        MAIN_SECTION_WIDTH4: "25\"",
        MAIN_SECTION_WIDTH5: "30\"",
        WITH_UPPER_ONE_SECTION: "Grid",
        TOP_ROW_HEIGHT: "20\"",
        ARCH_LEG_HEIGHT: "0\"",
        WITH_MAIN_ROW_SECTIONS: "5",
        MAIN_ROW_HEIGHT: "50\"",
        MAIN_ROW_WIDTH:  "150\"",
    },
    w19: {
        MAIN_SECTION_WIDTH1: "30\"",
        MAIN_SECTION_WIDTH2: "25\"",
        MAIN_SECTION_WIDTH3: "30\"",
        MAIN_SECTION_WIDTH4: "25\"",
        MAIN_SECTION_WIDTH5: "30\"",
        WITH_UPPER_ONE_SECTION: "Arch",
        TOP_ROW_HEIGHT: "20\"",
        ARCH_LEG_HEIGHT: "0\"",
        WITH_MAIN_ROW_SECTIONS: "5",
        MAIN_ROW_HEIGHT: "50\"",
        MAIN_ROW_WIDTH:  "150\"",
    },
    w20: {
        MAIN_SECTION_WIDTH1: "30\"",
        MAIN_SECTION_WIDTH2: "25\"",
        MAIN_SECTION_WIDTH3: "30\"",
        MAIN_SECTION_WIDTH4: "25\"",
        MAIN_SECTION_WIDTH5: "30\"",
        WITH_UPPER_ONE_SECTION: "Arch",
        TOP_ROW_HEIGHT: "20\"",
        ARCH_LEG_HEIGHT: "0\"",
        WITH_MAIN_ROW_SECTIONS: "3",
        MAIN_ROW_HEIGHT: "50\"",
        MAIN_ROW_WIDTH:  "150\"",
    },
    // ============================================
    // PATIO DOOR CONFIGURATIONS
    // ============================================
    pd1: {
        DOOR_TYPE: "Sliding",
        DOOR_WIDTH: "72\"",
        DOOR_HEIGHT: "80\"",
        PANEL_CONFIG: "2",
        FRAME_WIDTH: "3\"",
        UNIT_WIDTH: '58 3/4"',
        UNIT_HEIGHT: '79 1/4"',
        OPERATION_VENTING: 'XO(OSLI)',
    },
    pd2: {
        DOOR_TYPE: "TripleSliding",
        DOOR_WIDTH: "96\"",
        DOOR_HEIGHT: "80\"",
        PANEL_CONFIG: "3",
        FRAME_WIDTH: "3\"",
        UNIT_WIDTH: '89"',
        UNIT_HEIGHT: '79 1/4"',
        OPERATION_VENTING: 'OOX(OSLI)',
    },
    pd3: {
        DOOR_TYPE: "QuadSliding",
        DOOR_WIDTH: "60\"",
        DOOR_HEIGHT: "80\"",
        PANEL_CONFIG: "4",
        FRAME_WIDTH: "3\"",
        UNIT_WIDTH: '116 7/8"',
        UNIT_HEIGHT: '79 1/4"',
        OPERATION_VENTING: 'OXXO',
    },
    // Add more pages as needed
  };
export const companyName = "Demo";
export const companyDetails = {"details1":  "123 Greenwin Village Rd., Unit 9,",
                                "details2": "North York, Ontario M2R 2S8 Canada",
                                "details3": "Phone: 416-222-3344"};

export const companyDetails_Eticom = {"details1":"250 Shields Court, Unit 9, 2nd Floor,",
    "details2": "Markham, Ontario L3R 9W7 Canada",
    "details3": "Phone: 416-900-3793"};

  